<script setup lang="ts">
const items = [
  {
    title: 'Kerugian Finansial',
    description: 'Ongkir dan retur membengkak, tanpa kompensasi.',
    icon: 'material-symbols:credit-card-off-outline'
  },
  {
    title: 'Waktu Operasional Hilang',
    description: 'Tim sibuk mencari status paket manual di banyak ekspedisi.',
    icon: 'material-symbols:timer-off-outline'
  },
  {
    title: 'Reputasi Menurun',
    description: 'Pembeli kecewa karena tak ada update — rating toko turun.',
    icon: 'material-symbols:trending-down'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Kenapa Harus Peduli Saat Paket Gagal Kirim?"
    description="Gagal Kirim = Biaya, Waktu, dan Reputasi yang Terbuang"
    hero-image="/images/undelivery-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
